export enum MenuMode {
  APPLICATION_LISTING = "applicationListing",
  APPLICATION_DETAILS = "applicationDetails",
  NONE = "none",
  FOCUS = "focus",
}
